import Button from "@edaz/edazkit/Button/index";
import { IconType } from "@edaz/edazkit/Icon";
import { observer } from "mobx-react-lite";
import React from "react";
import cn from "classnames";

export interface FileProps {
  file: File;
  onRemoveClick: () => void;
  error?: string;
}

export const File = observer((props: FileProps) => {
  const className = cn("bg-light rounded p-3", {
    border: props.error,
    "border-danger": props.error,
    "mb-1": props.error,
    "mb-3": !props.error,
  });

  return (
    <>
      <div className={className}>
        <div className="row align-items-center">
          <div className="col font-weight-bold">{props.file.name}</div>
          <div className="col-auto">
            <Button iconLeft={IconType.Trash} size="sm" className="rounded" variant="danger" onClick={props.onRemoveClick} />
          </div>
        </div>
      </div>
      {props.error && <span className="invalid-feedback d-block mb-2">{props.error}</span>}
    </>
  );
});
